import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { Favorite } from './Favorite';

export const FavoriteVenue = inject('me')(
  observer(({ me, venueId, size, className }) => (
    <Favorite
      size={size}
      className={className}
      checked={me.isFavorite('venues', venueId)}
      onCheck={(checked) => me.setFavorite('venues', venueId, checked)}
    />
  ))
);

FavoriteVenue.propTypes = {
  venueId: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string,
};
